import type { TrackingAdapter } from '../types';

export const initializeTrackingAdapter = (
  trackingAdapter?: TrackingAdapter,
  trackLink?: TrackingAdapter['sendLinkEvent'],
  trackView?: TrackingAdapter['sendPageEvent'],
): TrackingAdapter => {
  let finalTrackingAdapter: TrackingAdapter = trackingAdapter!;
  if (trackLink || trackView) {
    finalTrackingAdapter = {
      sendLinkEvent: trackLink || (() => {}),
      sendPageEvent: trackView || (() => {}),
    };
  }

  return finalTrackingAdapter;
};
